import { useOverlay } from '../../../hooks/useOverlay';
import Container from '../../containers/container';
import Icon from '../../icons/icon';
import Text from '../../typography/v2/text';
import { HStack } from '../../layouts/stack.layout';
import { IconType } from '../../../types/icon.type';
import { v4 as uuid4 } from 'uuid';

type OverlayButtonProps = {
  icon: IconType;
  text: string;
  action: Function;
};

export default function OverlayOptionButton(props: OverlayButtonProps) {
  const [, closeOverlay] = useOverlay('SOCIAL_FEED');
  return (
    <Container
      onClick={() => {
        props.action();
        closeOverlay();
      }}
      key={uuid4()}
      extensions="w-full px-7 py-2.5 w-full "
    >
      <HStack gap="base" extensions="items-center w-full">
        <Icon color="gray" icon={props.icon} />
        <Text variant="overlay-text">{props.text}</Text>
      </HStack>
    </Container>
  );
}
